<template>
    <!-- 描述列表组件 -->
    <el-descriptions 
    :title="title"
    :column="column" 
    :size="size" 
    :border="border"
    :direction="direction"
    :extra="extra"
    :colon="colon"
    :label-class-name="labelClassName"
    :content-class-name="cntClassName"
    :labelStyle="labelStyle"
    :contentStyle="contentStyle"
    >   
        <!-- 头部操作插槽 -->
        <template v-slot:extra>
            <slot name="extra"></slot>
        </template>
        <!-- 描述列表主体 -->
        <template v-for="(d,dinx) in desList">
            <el-descriptions-item 
            :label="d.label"
            :label-class-name="d.labelClassName"
            :content-class-name="d.cntClassName"
            :labelStyle="d.labelStyle"
            :contentStyle="d.contentStyle"
            :key="d.label + dinx"
            >
                <!-- label -->
                <span slot='label'>
                    <VelIcon :iconName="d.icon" />
                    {{d.label}}
                </span>
                <!-- 值 -->
                <slot :name="d.slot" :cnt="d.cnt">
                    {{d.cnt}}
                </slot>
            </el-descriptions-item>
        </template>
    </el-descriptions>
</template>
<script>
import VelIcon from '../icon'
export default {
    name:"VelDes",
    components:{
        VelIcon
    },
    props:{
        column:Number,
        size:String,
        direction:String,
        title:String,
        extra:String,
        isColon:Boolean,
        isBorder:Boolean,
        labelClassName:String,
        cntClassName:String,
        labelStyle:Object,
        contentStyle:Object,
        desList:{
            type:Array,
            required:true,
        }
    },
    data() {
        return {
            border:false,
            colon:false,
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isColon ? this.colon = true : this.colon
            this.isBorder ? this.border = true : this.border
        }
    },
}
</script>
<style scoped>

</style>